import type { Faq } from "@components/Faq.js";
import type { Tenant } from "@core/schema/Tenant.js";
import { getIntegrationsPath } from "@core/schema/paths/getIntegrationsPath.js";

export function getFaqsHR(tenant: Tenant): Faq[] {
	return [
		{
			question:
				"Pokud bychom s vámi začali řešit optimalizaci HR procesů nebo vývoj softwaru, jak proběhne úvodní konzultace?",
			answer:
				"Na první schůzce s vámi projdeme současný stav vašich HR procesů, zjistíme vaše potřeby  a problémy nebo se zeptáme na další důležité podrobnosti. Na základě těchto informací pak můžeme navrhnout konkrétní kroky pro zlepšení. ",
		},
		{
			question: "Dokážete naše současné HR řešení propojit s dalšími nástroji, které už používáme?",
			answer: `Ano. Specializujeme se na [${getIntegrationsPath(tenant)}][[integraci]] nejrůznějších systémů, od účetních a docházkových po weby nebo firemní intranet. Rádi ověříme i možnosti propojení s vaším konkrétním nástrojem.`,
		},
		{
			question: "Jak rychle lze nové HR řešení nasadit do provozu?",
			answer:
				"Záleží na rozsahu a složitosti zadání, ale jednoduché moduly nasazujeme v řádu týdnů, komplexnější systémy obvykle do 3–6 měsíců. ",
		},
		{
			question: "Co když se v průběhu času změní naše požadavky nebo firma poroste?",
			answer:
				"Software i další řešení vytváříme s ohledem na budoucí rozšiřování. Nové funkce nebo úpravy umíme pružně doplnit, a to bez nutnosti stavět vše od nuly. Pomáhá nám v tom i cloudová architektura.",
		},
		{
			question: "Nabízíte i zaškolení pro zaměstnance, kteří budou s novým systémem pracovat?",
			answer: "Ano, zajistíme zaškolení všech uživatelů, kteří budou s novým řešením pracovat.",
		},
		{
			question:
				"Pokud si od Fastest necháme vytvořit nový systém na míru, můžeme do něj přenést data ze stávajícího systému?",
			answer:
				"Ano. Pomůžeme vám s migrací dat z Excelu, staršího HR softwaru nebo jiných databází, a to bezpečně a bez ztráty dat.",
		},
	];
}
